import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

export type Dayjs = dayjs.Dayjs

export type ManipulateType = dayjs.ManipulateType

export default dayjs

export type {} from "dayjs/plugin/utc"
